import { IAppConfig } from '@common/interfaces';

const configData = { ...window['EMODOCONFIG'], ...process.env };

/**
 * Application config
 */
const appConfig: IAppConfig = {
  env: configData.REACT_APP_ENV,
  bffApiUrl: configData.REACT_APP_BASE_BFF_API_URL,
  bffAuthApiUrl: configData.REACT_APP_BASE_BFF_AUTH_API_URL,
  geoUrl: configData.REACT_APP_BASE_GEO_URL,
  oktaUrl: configData.REACT_APP_OKTA_BASE_URL,
  oktaClientId: configData.REACT_APP_OKTA_CLIENT_ID,
  oktaRedirectUrl: configData.REACT_APP_OKTA_REDIRECT_URL,
  auth0Url: configData.REACT_APP_AUTH0_BASE_URL,
  auth0ClientId: configData.REACT_APP_AUTH0_CLIENT_ID,
  auth0RedirectUrl: configData.REACT_APP_AUTH0_REDIRECT_URL,
  logoutRedirectUrl: configData.REACT_APP_LOGOUT_REDIRECT_URL,
  tagJsUrl: configData.REACT_APP_TAG_JS_URL,
  mapBoxToken: configData.REACT_APP_MAPBOX_TOKEN,
};

export default appConfig;
